<template>
  <div class="comment__idea-audit">
    <span class="comment__idea-title">{{ ideaTitle }}</span>
    <div class="comment__audit-compare-content">
      <span class="comment__idea-audit-label is-opacity">{{ beforeLabel }}</span>
      <icon
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
        class="comment__audit-compare-content__arrow"
      />
      <span class="comment__idea-audit-label">{{ afterLabel }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

import { Comment } from "@/models"
import { Getters } from "@/store"

const props = defineProps<{
  comment: Comment
}>()

const store = useStore()

const ideaTitle = computed(() => store.getters[Getters.GET_IDEA]?.title ?? "")
const beforeLabel = computed(() => (props.comment.before?.ready ? "Ready" : "Not Ready"))
const afterLabel = computed(() => (props.comment.after?.ready ? "Ready" : "Not Ready"))
</script>
